module.exports = __webpack_public_path__ + "assets/f9f7d51dfe6213be62a4934f6443bdcf.png";